export const SettingsTab = {
  Gmail: "gmail",
  ApiKeys: "api-keys",
  MerchantAliases: "merchant-aliases",
  PaymentDetails: "payment-details",
} as const;
export type SettingsTab = (typeof SettingsTab)[keyof typeof SettingsTab];

export interface SettingsTabItem {
  id: SettingsTab;
  label: string;
}

export const SETTINGS_TABS: SettingsTabItem[] = [
  { id: SettingsTab.Gmail, label: "Gmail & Banks" },
  { id: SettingsTab.ApiKeys, label: "API Keys" },
  { id: SettingsTab.MerchantAliases, label: "Merchant Aliases" },
  { id: SettingsTab.PaymentDetails, label: "Payment Details" },
];

export const INPUT_CLASS =
  "rounded-lg border border-border bg-transparent px-3 py-1.5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/40";
